import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { MwService } from '~app/shared/services/mw/mw.service';

@Injectable()
export class PortCodeMasterResolver {
  constructor(private readonly mw: MwService) {}

  public resolve(): Observable<any> {
    return this.mw.getPortCodeMaster();
  }
}
